/* Native EU page enhancements. Shopify forms retain their normal POST fallback. */
(() => {
  if (window.QuadroEUPages) return;
  const all = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const show = (element, visible) => {
    if (!element) return;
    element.hidden = !visible;
    element.classList.toggle('hide', !visible);
  };
  const focus = element => {
    if (!element) return;
    if (!element.matches('input,select,button,a,textarea')) element.tabIndex = -1;
    element.focus();
  };
  let cardNumber = 0;
  function updateCard(select) {
    const card = select.closest('.product-card');
    if (!card) return;
    const option = select.selectedOptions?.[0] || select;
    const available = option.dataset.status !== 'unavailable';
    all('.button-available', card).forEach(el => {
      el.style.display = available ? '' : 'none';
      all('[type="submit"]', el).forEach(button => { button.disabled = !available; });
    });
    all('.button-unavailable', card).forEach(el => { el.style.display = available ? 'none' : ''; });
    const images = all('img[data-vid]', card);
    const matchingImage = images.find(img => img.dataset.vid === option.value && img.getAttribute('src'));
    if (matchingImage) {
      all('.list-view-item__image, .grid-view-item__image', card).forEach(img => { img.style.display = img === matchingImage ? '' : 'none'; });
    } else if (images.length) {
      all('.list-view-item__image, .grid-view-item__image', card).forEach((img, index) => { img.style.display = index === 0 ? '' : 'none'; });
    }
    all('[data-selected-variant-sku]', card).forEach(el => {
      el.textContent = option.dataset.sku || '';
      if (el.parentElement) el.parentElement.hidden = !el.textContent;
    });
    all('.product-list-link, .grid-view-item__image-container, [data-link="link"]', card).forEach(link => {
      const url = new URL(link.href, location.href);
      url.searchParams.set('variant', option.value);
      link.href = url.href;
    });
    all('input[data-eu-swatch]', card).forEach(radio => { radio.checked = radio.value === option.value; });
  }
  function initCards(scope) {
    all('.color-radios select[name="id"]', scope).forEach(select => {
      if (select.dataset.euBound) return;
      select.dataset.euBound = 'true';
      const card = select.closest('.product-card');
      const swatches = select.parentElement.querySelector('.variant-swatches');
      if (!card || !swatches) return;
      const group = `eu-card-${++cardNumber}`;
      Array.from(select.options).forEach((option, index) => {
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'color';
        radio.id = `${group}-${index}`;
        radio.value = option.value;
        radio.className = option.className;
        radio.dataset.euSwatch = '';
        radio.dataset.vid = option.value;
        radio.dataset.status = option.dataset.status;
        radio.setAttribute('aria-label', option.textContent.trim());
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          select.value = radio.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const label = document.createElement('label');
        label.htmlFor = radio.id;
        label.className = `colorVariant__label ${option.className}`;
        swatches.append(radio, label);
      });
      select.addEventListener('change', () => updateCard(select));
      updateCard(select);
    });
    all('.product-card input[type="hidden"][name="id"][data-status]', scope).forEach(updateCard);
    all('.variant-swatches [class]', scope).forEach(el => {
      Array.from(el.classList).forEach(name => {
        for (const color of ['berry', 'mint', 'petrol']) {
          if (new RegExp(`^(${color}-)+${color}$`).test(name)) el.classList.replace(name, color);
        }
      });
    });
  }
  function initPagination(scope) {
    all('[data-eu-pagination]', scope).forEach(pagination => {
      if (pagination.dataset.euBound) return;
      const container = document.getElementById(pagination.dataset.euPagination);
      if (!container) return;
      pagination.dataset.euBound = 'true';
      let busy = false;
      let failed = false;
      const visited = new Set([location.href]);
      const next = async () => {
        const link = pagination.querySelector('a[href]');
        if (!link || busy || failed) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || visited.has(url.href)) return;
        busy = true;
        pagination.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url.href, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Collection page request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.getElementById(container.id);
          const incomingPagination = html.getElementById(pagination.id);
          if (!incoming || !incomingPagination) throw new Error('Collection page markup missing');
          const list = container.querySelector('ul');
          const nextList = incoming.querySelector('ul');
          const items = Array.from((nextList || incoming).children).filter(el => el.tagName !== 'SCRIPT');
          if (!items.length) throw new Error('Collection page empty');
          (list || container).append(...items);
          pagination.replaceChildren(...Array.from(incomingPagination.childNodes));
          visited.add(url.href);
          initCards(container);
          window.QuadroEU?.init(container);
          window.QuadroEUCollection?.init(container);
        } catch (error) {
          // Keep the real next-page link usable if the enhancement cannot load it.
          failed = true;
        } finally {
          busy = false;
          pagination.removeAttribute('aria-busy');
        }
      };
      pagination.addEventListener('click', event => {
        if (!event.target.closest('a[href]') || failed || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        next();
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) next(); }, { rootMargin: '250px' });
        observer.observe(pagination);
      }
    });
    all('#SortBy', scope).forEach(select => {
      if (select.dataset.euBound) return;
      select.dataset.euBound = 'true';
      select.classList.remove('hidden');
      select.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        location.assign(url.href);
      });
    });
    all('#BlogTagFilter', scope).forEach(select => {
      if (select.dataset.euBound) return;
      select.dataset.euBound = 'true';
      select.addEventListener('change', () => {
        const url = new URL(select.value, location.href);
        if (url.origin === location.origin) location.assign(url.href);
      });
    });
  }
  function initAccounts() {
    const login = document.getElementById('CustomerLoginForm');
    const recovery = document.getElementById('RecoverPasswordForm');
    const recover = (active, moveFocus = true) => {
      show(login, !active); show(recovery, active);
      if (moveFocus) focus(document.getElementById(active ? 'RecoverHeading' : 'LoginHeading'));
    };
    document.getElementById('RecoverPassword')?.addEventListener('click', event => { event.preventDefault(); recover(true); });
    document.getElementById('HideRecoverPasswordLink')?.addEventListener('click', event => { event.preventDefault(); recover(false); });
    if (login && recovery) {
      recover(location.hash === '#recover' || !!recovery.querySelector('.input--error'), false);
      window.addEventListener('hashchange', () => recover(location.hash === '#recover'));
      if (document.querySelector('.reset-password-success')) {
        recover(false, false); show(document.getElementById('ResetSuccess'), true); focus(document.getElementById('ResetSuccess'));
      }
    }
    const toggleAddress = (targetId, trigger) => {
      const target = document.getElementById(targetId);
      if (!target) return;
      const visible = target.classList.contains('hide') || target.hidden;
      show(target, visible);
      all(`[aria-owns="${targetId}"]`).forEach(button => button.setAttribute('aria-expanded', String(visible)));
      focus(visible ? target.querySelector('input:not([type="hidden"])') : document.querySelector(`[aria-owns="${targetId}"]`) || trigger);
    };
    all('.address-new-toggle').forEach(button => button.addEventListener('click', () => toggleAddress('AddressNewForm', button)));
    all('.address-edit-toggle').forEach(button => button.addEventListener('click', () => toggleAddress(`EditAddress_${button.dataset.formId}`, button)));
    all('select[id^="AddressCountry"]').forEach(country => {
      const suffix = country.id.slice('AddressCountry'.length);
      const province = document.getElementById(`AddressProvince${suffix}`);
      const container = document.getElementById(`AddressProvinceContainer${suffix}`);
      const defaultCountry = country.dataset.default;
      const option = Array.from(country.options).find(item => item.value === defaultCountry || item.textContent === defaultCountry);
      if (option) country.value = option.value;
      const provinces = initial => {
        let values = [];
        try { values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) { /* Native empty list fallback. */ }
        if (!province) return;
        province.replaceChildren(...values.map(([value, label]) => new Option(label, value)));
        province.disabled = !values.length;
        if (container) container.style.display = values.length ? '' : 'none';
        if (initial) {
          const match = Array.from(province.options).find(item => item.value === province.dataset.default || item.textContent === province.dataset.default);
          if (match) province.value = match.value;
        }
      };
      provinces(true);
      country.addEventListener('change', () => provinces(false));
    });
    all('.address-delete').forEach(button => button.addEventListener('click', () => {
      if (!window.confirm(button.dataset.confirmMessage)) return;
      const url = new URL(button.dataset.target, location.href);
      if (url.origin !== location.origin) return;
      const form = document.createElement('form');
      form.method = 'post'; form.action = url.href;
      const method = document.createElement('input');
      method.type = 'hidden'; method.name = '_method'; method.value = 'delete';
      form.append(method); document.body.append(form); form.submit();
    }));
  }
  function initPassword() {
    const dialog = document.getElementById('LoginModal');
    if (!dialog) return;
    const opener = document.querySelector('.js-modal-open-login-modal');
    const close = () => { dialog.classList.remove('modal--is-active'); dialog.setAttribute('aria-hidden', 'true'); document.body.classList.remove('modal-open'); focus(opener); };
    const open = () => { dialog.classList.add('modal--is-active'); dialog.setAttribute('aria-hidden', 'false'); document.body.classList.add('modal-open'); focus(dialog.querySelector('[data-login-field]')); };
    opener?.addEventListener('click', event => { event.preventDefault(); open(); });
    dialog.querySelector('.js-modal-close')?.addEventListener('click', close);
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const fields = all('a[href],button,input:not([type="hidden"]),select,textarea', dialog).filter(el => !el.disabled && el.getClientRects().length);
      const first = fields[0], last = fields[fields.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    dialog.setAttribute('aria-hidden', 'true');
    if (dialog.querySelector('[data-error="password"]') || location.hash === '#LoginModal') open();
  }
  function initEmbeds() {
    const iframe = document.querySelector('[data-eu-downloads]');
    if (!iframe) return;
    const update = () => {
      const code = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
      const language = code === 'pt' ? 'pt-pt' : ['de','es','fr','hu','it','nl','pl','ru','sk','sl'].includes(code) ? code : 'en';
      const source = `https://apps.quadroworld.com/${language}/node/1261`;
      if (iframe.src !== source) iframe.src = source;
    };
    update();
    if (window.iFrameResize) window.iFrameResize({ log: false, checkOrigin: ['https://apps.quadroworld.com'] }, iframe);
    new MutationObserver(update).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }
  function initGiftCard() {
    const qr = document.getElementById('QrCode');
    if (qr && window.QRCode) new window.QRCode(qr, { text: qr.dataset.identifier, width: 120, height: 120, imageAltText: qr.dataset.alt });
    document.getElementById('GiftCardDigits')?.addEventListener('focus', event => event.target.select());
  }
  function init(scope = document) { initCards(scope); initPagination(scope); }
  window.QuadroEUPages = { init };
  const start = () => {
    init(); initAccounts(); initPassword(); initEmbeds(); initGiftCard();
    const query = new URLSearchParams(location.search);
    all('.old-subscriber').forEach(el => el.classList.toggle('old-subscriber-true', query.get('contact[tags]') === 'newsletter' && query.get('form_type') === 'customer'));
    const status = document.querySelector('[data-form-status]');
    if (status && status.getClientRects().length) focus(status);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
